export default __webpack_public_path__ + "static/media/304118.8ff130b2.jpg";